export function isFoodExpiredSession(user: any, subscription: any) {
  if (String(user?.role || '').toUpperCase() !== 'USER') return false
  if (user?.pendingActivation === true) return false
  if (String(subscription?.status || '').toUpperCase() === 'PENDING') return false
  if (user?.planExpired === true) return true
  if (String(subscription?.status || '').toUpperCase() === 'EXPIRED') return true
  const end = subscription?.endDate || subscription?.end_date
  if (end && Number.isFinite(new Date(end).getTime()) && new Date(end).getTime() < Date.now()) {
    return true
  }
  return false
}
